import { LocaleIdentifier } from '@repo/markets/types'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { useState } from 'react'

const useLocaleChange = (currentLocale: LocaleIdentifier) => {
  const pathname = usePathname()
  const router = useRouter()
  const searchParams = useSearchParams()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const changeLocale = (newLocale: LocaleIdentifier) => {
    setIsLoading(true)

    const newUrl = `${pathname.replace(`/${currentLocale}`, `/${newLocale}`)}?${searchParams.toString()}`

    router.push(newUrl)
    router.refresh()

    setTimeout(() => {
      setIsLoading(false)
    }, 1000)
  }

  return { changeLocale, isLoading }
}

export default useLocaleChange
